import BaseService from './base.service'
const API_URL = process.env.VUE_APP_API_URL
class ReportService extends BaseService {
    getDailySalesReport(date, game_type_slug, product_slug) {
        return this.post(API_URL + `api/report/sales?date=${date?date:""}&game_type_slug=${game_type_slug?game_type_slug:""}&product_slug=${product_slug?product_slug:""}`, {}).then((response) => {
            return response.data
        })
    }
    
    getWeeklySalesReport(from, to, game_type_slug, product_slug) {
        return this.post(API_URL + `api/report/sales?from=${from?from:""}&to=${to?to:""}&game_type_slug=${game_type_slug?game_type_slug:""}&product_slug=${product_slug?product_slug:""}`, {}).then((response) => {
            return response.data
        })
    }
    getListWeeks() {
        return this.get(API_URL + `api/report/list-weeks`).then((response) => {
            return response.data
        })
    }
}

export default new ReportService()
